














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Container from '@/components/atoms/Grid/Container.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TextField from '@/components/atoms/TextField/TextField.vue';
import { toNumber } from '@/utils/moneyTreatments';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    FilledButton,
    FormLabel,
    Container,
    Checkbox,
    TextField,
    Typography
  }
})
export default class CoinStoreSendCoins extends Vue {
  @Prop() readonly data!: any;
  coins = '';
  autoSendingCoinStoreAmount = '';
  autoSendingCoinStore = false;

  adminService = new AdminService();

  async changeAutoSendingCoinStoreStatus() {
    this.autoSendingCoinStore = !this.autoSendingCoinStore;
  }

  async saveAutoSendCoinsStore() {
    if (!this.isValidAutoSendCoinsAmount()) {
      return;
    }
    try {
      const { status } = await this.adminService.enableAutoSendingCoinStore(
        this.data.id,
        this.autoSendingCoinStore,
        toNumber(this.autoSendingCoinStoreAmount)
      );

      if (status === 201) {
        this.$notification('Success');
      }
    } catch (e) {
      this.autoSendingCoinStore = !this.autoSendingCoinStore;
      treatError(e);
    }
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get autoSendingCoinsEnabled() {
    return this.flags.includes(flagKeys.coinStoreAutoSendingCoins);
  }

  get hasCoinsToSend() {
    return toNumber(this.data.coins) > 0;
  }

  get coinsAvailable() {
    return this.data.coins;
  }

  get subscriptionFee() {
    return this.data.subscriptionFee;
  }

  isValidSendCoins() {
    const coins = this.coins;
    if (toNumber(coins) <= 0) {
      this.$notification('Please fill the fields', 'error');
      return false;
    }
    if (toNumber(coins) > toNumber(this.data.coins)) {
      this.$notification(
        'This wallet has insufficient funds at the moment',
        'error'
      );
      return false;
    }
    return true;
  }

  isValidAutoSendCoinsAmount() {
    const autoSendingCoinStoreAmount = this.autoSendingCoinStoreAmount;
    const autoSendingCoinStore = this.autoSendingCoinStore;
    if (!autoSendingCoinStore) {
      return true;
    }
    if (toNumber(autoSendingCoinStoreAmount) <= 0) {
      this.$notification('Please fill the fields', 'error');
      return false;
    }
    if (toNumber(autoSendingCoinStoreAmount) > this.data.subscriptionFee) {
      this.$notification(
        'This amount exceeds the weekly available coins',
        'error'
      );
      return false;
    }
    return true;
  }

  async sendCoins() {
    if (!this.isValidSendCoins()) {
      return;
    }

    const onConfirm = async () => {
      try {
        const { status } = await this.adminService.sendTwismCoinsToCoinStore(
          this.data.id,
          toNumber(this.coins)
        );

        if (status === 201) {
          this.$notification('Success');
          eventBus.$emit('closeModal');
          eventBus.$emit('reloadTwismWallet', false);
          eventBus.$emit('reloadTwismWalletHistory');
          this.closeModal();
        }
      } catch (e) {
        treatError(e);
      }
    };

    const coins = this.coins;
    const description = `${toNumber(coins)} Coins will be sent to Coin Store`;
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'coinStoreConfirmModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        data: {
          coins: toNumber(coins)
        },
        title: `Are you sure?`,
        subtitle: description,
        onConfirm
      }
    );
  }

  closeModal() {
    if (this.data.close) {
      this.data.close();
    }
  }

  mounted() {
    this.autoSendingCoinStore = this.data.autoSendingCoinStore;
    this.autoSendingCoinStoreAmount = this.data.autoSendingCoinStoreAmount;
  }
}
